
import { LoginForm } from "@/components/formik/auth/LoginForm";
import AuthLayout from "@/components/layouts/AuthLayout";

export const LoginView = () => {
  return (
          <AuthLayout
              title="Log in to your account"
              subtitle="Welcome back! Please enter your details."
          >
              <LoginForm/>
          </AuthLayout>
)
};
